import { Component, OnInit } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {UtilService} from '../../service/util.service';

@Component({
  selector: 'app-clients',
  templateUrl: './clients.component.html',
  styleUrls: ['./clients.component.css']
})
export class ClientsComponent implements OnInit {

  constructor(private http: HttpClient, private util: UtilService) { }
  clientList: Observable<string[]>;

  ngOnInit(): void {
    this.getClients();
  }

  getClients() {
    this.clientList = this.http.get<string[]>(this.util.getUrl('clients.json'));
  }

}
